import { reducerWithInitialState } from 'typescript-fsa-reducers'
import produce from 'immer'

import { User } from '~api/models'
import { AsyncModel } from '~shared/models/AsyncModel'
import { MsalAccountInfo } from '~shared/models/msalExtendedTypes'
import { signInComplete, signOutComplete, fetchUser } from './actions'

export interface AccountState {
  accountInfo?: MsalAccountInfo
  user: AsyncModel<User>
}

const INITIAL_STATE: AccountState = {
  user: { inProgress: true }, // setting this to show spinner on first render
}

export const accountReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * sign in/out
   */
  .case(signInComplete, (state, payload) => {
    return produce(state, (draft: AccountState) => {
      draft.accountInfo = payload
    })
  })
  .case(signOutComplete, () => {
    return INITIAL_STATE
  })

  /**
   * fetchUser
   */
  .case(fetchUser.started, (state) => {
    return produce(state, (draft: AccountState) => {
      draft.user.inProgress = true
      draft.user.error = undefined
    })
  })
  .case(fetchUser.done, (state, payload) => {
    return produce(state, (draft: AccountState) => {
      draft.user.inProgress = false
      draft.user.payload = payload.result
    })
  })
  .case(fetchUser.failed, (state, payload) => {
    return produce(state, (draft: AccountState) => {
      draft.user.inProgress = false
      draft.user.error = payload.error
    })
  })
